import { render, staticRenderFns } from "./FourOhFour.vue?vue&type=template&id=9a3eddba&"
import script from "./FourOhFour.vue?vue&type=script&lang=js&"
export * from "./FourOhFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports